import React, { useEffect } from 'react';

export default function TermsConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      maxWidth: '900px',
      margin: '40px auto',
      padding: '0 20px',
      lineHeight: '1.8',
      color: '#333',
      textAlign: 'left'
    }}>
      <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>Terms and Conditions</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>Last updated: {new Date().toLocaleDateString()}</p>
      
      <div style={{ fontSize: '15px', textAlign: 'left' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>1. Agreement to Terms</h2>
          <p style={{ marginBottom: '15px' }}>
            Welcome to Bokeh ("Company," "we," "our," or "us"). These Terms and Conditions ("Terms") govern your access to and use of our website 
            <a href="https://bokehclo.com" style={{ color: '#000', textDecoration: 'underline', margin: '0 4px' }}>https://bokehclo.com</a> 
            and the purchase of products through our online store.
          </p>
          <p style={{ marginBottom: '15px' }}>
            By accessing or using our website, you agree to be bound by these Terms. If you do not agree with any part of these Terms, 
            you must not use our website or purchase our products.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>2. Use of Our Website</h2>
          
          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Eligibility</h3>
          <p style={{ marginBottom: '15px' }}>
            By using our website and making a purchase, you represent and warrant that you have the legal capacity to enter 
            into a binding contract and that all information you provide is accurate and complete.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Account Security</h3>
          <p style={{ marginBottom: '15px' }}>
            If you create an account on our website, you are responsible for maintaining the confidentiality of your account 
            credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Prohibited Activities</h3>
          <p style={{ marginBottom: '15px' }}>
            You agree not to:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Use our website for any illegal purpose or in violation of any laws</li>
            <li>Attempt to gain unauthorized access to our systems or networks</li>
            <li>Interfere with or disrupt the operation of our website</li>
            <li>Use automated systems (bots, scrapers) without our written permission</li>
            <li>Reproduce, duplicate, copy, or resell any part of our website</li>
            <li>Transmit any viruses, malware, or harmful code</li>
            <li>Engage in fraudulent activities or misrepresent your identity</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>3. Products and Pricing</h2>
          
          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Product Information</h3>
          <p style={{ marginBottom: '15px' }}>
            We make every effort to display our products as accurately as possible. However, we cannot guarantee that your device's 
            display of colors, sizes, or other product details will be accurate. Product descriptions, images, and specifications are 
            subject to change without notice.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Pricing</h3>
          <p style={{ marginBottom: '15px' }}>
            All prices are displayed in USD (United States Dollars) and are subject to change without notice. We reserve the right to 
            modify prices at any time. The price charged for a product will be the price displayed at the time you submit your order.
          </p>
          <p style={{ marginBottom: '15px' }}>
            Prices do not include applicable taxes or shipping costs, which will be added at checkout.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Product Availability</h3>
          <p style={{ marginBottom: '15px' }}>
            All products are subject to availability. We reserve the right to discontinue any product at any time. In the event that a 
            product is unavailable after you place an order, we will notify you and provide a full refund.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>4. Orders and Payment</h2>
          
          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Order Process</h3>
          <p style={{ marginBottom: '15px' }}>
            When you place an order, you will receive an email confirmation. This confirmation does not constitute our acceptance of your order. 
            We reserve the right to accept or decline your order for any reason, including but not limited to:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Product availability</li>
            <li>Errors in product or pricing information</li>
            <li>Suspected fraudulent transactions</li>
            <li>Payment authorization issues</li>
          </ul>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Payment Methods</h3>
          <p style={{ marginBottom: '15px' }}>
            We accept payment through <strong>Stripe</strong> and <strong>PayPal</strong>. By providing payment information, you represent 
            and warrant that you are authorized to use the payment method and authorize us to charge the total amount of your order.
          </p>
          <p style={{ marginBottom: '15px' }}>
            All payment information is processed securely through our third-party payment processors. We do not store your complete payment 
            card details on our servers.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Order Confirmation</h3>
          <p style={{ marginBottom: '15px' }}>
            Once your order is confirmed and payment is processed, you will receive an order confirmation email with your order details 
            and estimated delivery timeframe.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>5. Shipping and Delivery</h2>
          <p style={{ marginBottom: '15px' }}>
            We ship to addresses within the United States and internationally (where available). Shipping costs and delivery times 
            vary based on your location and selected shipping method.
          </p>
          <p style={{ marginBottom: '15px' }}>
            Delivery timeframes are estimates only and are not guaranteed. We are not responsible for delays caused by:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Shipping carriers</li>
            <li>Customs processing (for international orders)</li>
            <li>Weather conditions or natural disasters</li>
            <li>Incorrect or incomplete shipping addresses provided by you</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            You are responsible for providing accurate shipping information. If a package is returned to us due to an incorrect address, 
            you may be charged for reshipping.
          </p>
          <p style={{ marginBottom: '15px' }}>
            Risk of loss and title for products pass to you upon delivery to the shipping carrier. We use <strong>Shippo</strong> to 
            facilitate shipping and provide tracking information.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>6. Returns and Refunds</h2>
          <p style={{ marginBottom: '15px' }}>
            <strong>All sales are final.</strong> We do not accept returns or offer refunds at this time. Please carefully review your 
            order before completing your purchase, as we cannot accept returns or exchanges for any reason.
          </p>
          <p style={{ marginBottom: '15px' }}>
            If you receive a damaged or defective product, please contact us at <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>contact@bokehclo.com</a> within 
            48 hours of delivery with photos of the damage. We will review each case individually and determine the appropriate resolution at our sole discretion.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>7. Intellectual Property Rights</h2>
          <p style={{ marginBottom: '15px' }}>
            All content on our website, including but not limited to text, graphics, logos, images, product descriptions, and software, 
            is the property of Bokeh or its content suppliers and is protected by United States and international copyright, trademark, 
            and other intellectual property laws.
          </p>
          <p style={{ marginBottom: '15px' }}>
            You may not:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Copy, reproduce, or distribute any content from our website without written permission</li>
            <li>Use our trademarks, logos, or brand names without authorization</li>
            <li>Create derivative works based on our content</li>
            <li>Remove or alter any copyright, trademark, or other proprietary notices</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>8. Product Warranties and Disclaimers</h2>
          <p style={{ marginBottom: '15px' }}>
            We strive to provide high-quality products. However, to the maximum extent permitted by law:
          </p>
          <p style={{ marginBottom: '15px' }}>
            OUR PRODUCTS ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO 
            IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
          </p>
          <p style={{ marginBottom: '15px' }}>
            We do not warrant that:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Products will meet your specific requirements</li>
            <li>Products will be error-free or defect-free</li>
            <li>The website will be uninterrupted or error-free</li>
            <li>Any defects will be corrected</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            Some jurisdictions do not allow limitations on implied warranties, so these limitations may not apply to you.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>9. Limitation of Liability</h2>
          <p style={{ marginBottom: '15px' }}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, BOKEH SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, 
            OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, 
            USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Your use or inability to use our website or products</li>
            <li>Any unauthorized access to or use of our servers or your personal information</li>
            <li>Any interruption or cessation of transmission to or from our website</li>
            <li>Any bugs, viruses, or harmful code transmitted through our website</li>
            <li>Any errors or omissions in any content or product information</li>
            <li>Any defective or damaged products</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            In no event shall Bokeh be liable to you for any monetary damages, compensation, or financial reimbursement of any kind 
            beyond what is expressly required by law.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>10. Indemnification</h2>
          <p style={{ marginBottom: '15px' }}>
            You agree to indemnify, defend, and hold harmless Bokeh, its employees, and affiliates from 
            and against any claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising from:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Your use of our website or products</li>
            <li>Your violation of these Terms</li>
            <li>Your violation of any rights of another party</li>
            <li>Your violation of any applicable laws or regulations</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>11. Dispute Resolution and Governing Law</h2>
          
          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Governing Law</h3>
          <p style={{ marginBottom: '15px' }}>
            These Terms shall be governed by and construed in accordance with the laws of the United States and the state in which 
            Bokeh operates, without regard to its conflict of law provisions.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Informal Resolution</h3>
          <p style={{ marginBottom: '15px' }}>
            Before filing a claim, you agree to contact us at <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>contact@bokehclo.com</a> to 
            attempt to resolve any dispute informally. We will attempt to resolve the dispute within 60 days.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Jurisdiction</h3>
          <p style={{ marginBottom: '15px' }}>
            You agree that any legal action or proceeding arising out of or relating to these Terms shall be brought exclusively in 
            the federal or state courts located in the United States, and you consent to the personal jurisdiction of such courts.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>12. Privacy</h2>
          <p style={{ marginBottom: '15px' }}>
            Your privacy is important to us. Please review our <a href="/privacy-policy" style={{ color: '#000', textDecoration: 'underline' }}>Privacy Policy</a> to 
            understand how we collect, use, and protect your personal information.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>13. Modifications to Terms</h2>
          <p style={{ marginBottom: '15px' }}>
            We reserve the right to modify these Terms at any time. We will notify you of any material changes by posting the updated 
            Terms on this page and updating the "Last updated" date at the top of this page.
          </p>
          <p style={{ marginBottom: '15px' }}>
            Your continued use of our website after any changes constitutes your acceptance of the new Terms. If you do not agree to 
            the modified Terms, you must stop using our website.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>14. Termination</h2>
          <p style={{ marginBottom: '15px' }}>
            We reserve the right to terminate or suspend your access to our website immediately, without prior notice or liability, 
            for any reason, including but not limited to:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Breach of these Terms</li>
            <li>Fraudulent or illegal activity</li>
            <li>Providing false information</li>
            <li>At our sole discretion</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            Upon termination, your right to use our website will immediately cease. All provisions of these Terms that by their nature 
            should survive termination shall survive, including but not limited to ownership provisions, warranty disclaimers, and limitations of liability.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>15. Severability</h2>
          <p style={{ marginBottom: '15px' }}>
            If any provision of these Terms is found to be invalid, illegal, or unenforceable, the remaining provisions shall continue 
            in full force and effect. The invalid provision shall be modified to the minimum extent necessary to make it valid and enforceable.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>16. Entire Agreement</h2>
          <p style={{ marginBottom: '15px' }}>
            These Terms, together with our Privacy Policy and Return & Refund Policy, constitute the entire agreement between you and 
            Bokeh regarding your use of our website and supersede all prior agreements and understandings.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>17. Contact Information</h2>
          <p style={{ marginBottom: '15px' }}>
            If you have any questions, concerns, or complaints regarding these Terms, please contact us at:
          </p>
          <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', marginTop: '15px' }}>
            <p style={{ marginBottom: '8px' }}><strong>Bokeh</strong></p>
            <p style={{ marginBottom: '8px' }}>Email: <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>contact@bokehclo.com</a></p>
            <p style={{ marginBottom: '8px' }}>Website: <a href="https://bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>https://bokehclo.com</a></p>
          </div>
        </section>

        <section style={{ marginBottom: '30px', marginTop: '40px', padding: '20px', background: '#f0f0f0', borderRadius: '5px' }}>
          <p style={{ fontSize: '13px', color: '#666', fontStyle: 'italic', marginBottom: '0' }}>
            <strong>Disclaimer:</strong> These Terms and Conditions are provided as a general template and may not cover all legal requirements 
            for your specific jurisdiction or business situation. For complete legal compliance, we recommend consulting with a qualified 
            attorney who specializes in e-commerce law.
          </p>
        </section>
      </div>
    </div>
  );
}

